import { Control, DomEvent, DomUtil, GridLayer, Util } from 'leaflet';

const DEFAULT_TILES_ENDPOINT = 'https://tile.googleapis.com/v1/2dtiles';
const DEFAULT_SESSION_ENDPOINT = 'https://tile.googleapis.com/v1/createSession';
const DEFAULT_VIEWPORT_ENDPOINT = 'https://tile.googleapis.com/tile/v1/viewport';
const DEFAULT_REFRESH_MARGIN_SECONDS = 300;
const DEFAULT_LOGO_URL =
  'data:image/svg+xml;base64,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';
const DEFAULT_LOGO_DP_HEIGHT = 18;
const LATITUDE_EPSILON = 1e-6;
const LONGITUDE_EPSILON = 1e-6;

export class GoogleTileLayer extends GridLayer {
  constructor(options) {
    if (!options || !options.apiKey) {
      throw new Error('GoogleTileLayer requires an apiKey option');
    }

    const baseAttribution =
      typeof options.attribution === 'string' ? options.attribution.trim() : '';
    const initialDataAttribution =
      options.dataAttribution === undefined || options.dataAttribution === null
        ? ''
        : String(options.dataAttribution).trim();

    const mergedOptions = {
      tileSize: 256,
      updateWhenIdle: true,
      ...options,
      showGoogleLogo: options.showGoogleLogo !== false,
      googleLogoUrl: options.googleLogoUrl || DEFAULT_LOGO_URL,
      googleLogoHeight: options.googleLogoHeight || DEFAULT_LOGO_DP_HEIGHT,
      googleLogoPosition: options.googleLogoPosition || 'bottomleft',
      googleAttributionPrefix: options.googleAttributionPrefix,
      autoViewportAttribution: options.autoViewportAttribution !== false,
      autoViewportMaxNativeZoom: options.autoViewportMaxNativeZoom !== false,
      viewportEndpoint: options.viewportEndpoint || DEFAULT_VIEWPORT_ENDPOINT,
      attribution: '',
      dataAttribution: initialDataAttribution,
    };

    super(mergedOptions);
    Util.setOptions(this, mergedOptions);

    this._baseAttribution = baseAttribution;
    this._logoControl = undefined;
    this._sessionToken = options.session;
    this._sessionExpiry = undefined;
    this._sessionPromise = this._sessionToken ? Promise.resolve() : undefined;
    this._pendingAddMap = undefined;
    this._dataAttribution = initialDataAttribution;
    this._originalAttributionPrefix = undefined;
    this._attributionEntry = undefined;
    this._viewportListener = undefined;
    this._viewportPromise = undefined;
    this._viewportQueued = false;
    const userMaxNativeZoom = this._sanitizeZoomValue(options.maxNativeZoom);
    this._userMaxNativeZoom = Number.isFinite(userMaxNativeZoom) ? userMaxNativeZoom : undefined;
    const userMaxZoom = this._sanitizeZoomValue(options.maxZoom);
    this._userMaxZoom = Number.isFinite(userMaxZoom) ? userMaxZoom : undefined;
    this._dynamicMaxNativeZoom = undefined;
    this._lastViewportMaxZoom = this._userMaxNativeZoom ?? this._userMaxZoom;

    void this._ensureSession();
  }

  onAdd(map) {
    this._pendingAddMap = map;

    void this._ensureSession()
      .then(() => {
        if (this._pendingAddMap === map) {
          super.onAdd(map);
          this._pendingAddMap = undefined;
          this._integrateLeafletAttribution(map);
          this._ensureLogoControl(map);

          const wantsViewportMetadata =
            this.options.autoViewportAttribution !== false || this.options.autoViewportMaxNativeZoom;

          if (wantsViewportMetadata) {
            this._bindViewportListeners(map);
            void this.refreshViewportAttribution({
              applyAttribution: this.options.autoViewportAttribution !== false,
            });
          }

          if (this.options.autoViewportAttribution === false) {
            this._applyLeafletAttribution();
          }
        }
      })
      .catch((error) => {
        this._pendingAddMap = undefined;
        if (typeof this.options.onSessionError === 'function') {
          this.options.onSessionError({ error });
        }
      });

    return this;
  }

  onRemove(map) {
    this._pendingAddMap = undefined;
    this._unbindViewportListeners(map);
    this._removeLogoControl(map);
    this._restoreLeafletAttribution(map);
    if (this._map) {
      super.onRemove(map);
    }
    return this;
  }

  createTile(coords, done) {
    const tile = document.createElement('img');
    const coordLabel = `${coords.z}/${coords.x}/${coords.y}`;

    DomEvent.on(tile, 'load', () => {
      DomEvent.off(tile, 'load');
      DomEvent.off(tile, 'error');
      if (typeof done === 'function') {
        done(null, tile);
      }
    });
    DomEvent.on(tile, 'error', (event) => {
      DomEvent.off(tile, 'load');
      DomEvent.off(tile, 'error');
      const error =
        event instanceof Error
          ? event
          : (() => {
              const err = new Error(`Failed to load Google map tile ${coordLabel}`);
              err.originalEvent = event;
              return err;
            })();
      if (typeof done === 'function') {
        done(error, tile);
      }
    });

    tile.alt = '';
    tile.setAttribute('role', 'presentation');
    tile.decoding = 'async';

    const { crossOrigin, referrerPolicy } = this.options;
    if (crossOrigin) {
      tile.crossOrigin = crossOrigin === true ? '' : crossOrigin;
    }
    if (referrerPolicy) {
      tile.referrerPolicy = referrerPolicy;
    }

    void this._ensureSession()
      .then(() => {
        tile.src = this._buildTileUrl(coords);
      })
      .catch((error) => {
        done(error instanceof Error ? error : new Error(String(error)));
      });

    return tile;
  }


  async ready() {
    await this._ensureSession();
  }

  async refreshSession(force = false) {
    if (force) {
      this._clearSession();
    }

    await this._fetchSession();

    if (this._map) {
      this.redraw();
      this._applyLeafletAttribution();
    }
  }

  setSession(session, expiry) {
    this._sessionToken = session;
    this._sessionExpiry = expiry;
    this.options.session = session;
    this._sessionPromise = Promise.resolve();
    if (typeof this.options.onSessionCreated === 'function') {
      this.options.onSessionCreated({ session, expiry });
    }
    if (this._map) {
      this.redraw();
      this._applyLeafletAttribution();
    }
  }

  _clearSession() {
    this._sessionToken = undefined;
    this._sessionExpiry = undefined;
    this.options.session = undefined;
    this._sessionPromise = undefined;
  }

  async _ensureSession() {
    if (this._sessionToken && this._isSessionValid()) {
      return;
    }

    if (this._sessionToken && !this._sessionExpiry) {
      return;
    }

    if (!this._sessionPromise) {
      this._sessionPromise = this._fetchSession().finally(() => {
        this._sessionPromise = undefined;
      });
    }

    await this._sessionPromise;
  }

  _isSessionValid() {
    if (!this._sessionToken) {
      return false;
    }

    if (!this._sessionExpiry) {
      return true;
    }

    const margin =
      typeof this.options.refreshSessionBeforeSec === 'number'
        ? this.options.refreshSessionBeforeSec
        : DEFAULT_REFRESH_MARGIN_SECONDS;
    const nowSeconds = Date.now() / 1000;
    return nowSeconds < this._sessionExpiry - margin;
  }

  async _fetchSession() {
    if (this.options.session) {
      this._sessionToken = this.options.session;
      this._sessionExpiry = undefined;
      if (typeof this.options.onSessionCreated === 'function') {
        this.options.onSessionCreated({ session: this.options.session });
      }
      this._applyLeafletAttribution();
      return;
    }

    const fetchFn = this.options.fetchImplementation || globalThis.fetch;
    if (!fetchFn) {
      throw new Error('No fetch implementation available to create a Google Map Tiles session');
    }

    const endpoint = (this.options.sessionEndpoint || DEFAULT_SESSION_ENDPOINT).replace(/\/$/, '');
    const url = `${endpoint}?key=${encodeURIComponent(this.options.apiKey)}`;
    const requestBody = this._buildSessionRequestBody();

    const response = await fetchFn(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const error = new Error(
        `Failed to create Map Tiles session: ${response.status} ${response.statusText}`
      );
      if (typeof this.options.onSessionError === 'function') {
        this.options.onSessionError({ error });
      }
      throw error;
    }

    const data = await response.json();
    if (!data || !data.session) {
      const error = new Error('Google Map Tiles session response did not include a session token');
      if (typeof this.options.onSessionError === 'function') {
        this.options.onSessionError({ error });
      }
      throw error;
    }

    this._sessionToken = data.session;
    this.options.session = data.session;

    if (data.expiry) {
      const parsed = Number.parseInt(String(data.expiry), 10);
      if (!Number.isNaN(parsed)) {
        this._sessionExpiry = parsed;
      }
    }

    if (typeof this.options.onSessionCreated === 'function') {
      this.options.onSessionCreated({ session: data.session, expiry: this._sessionExpiry });
    }

    this._applyLeafletAttribution();
  }

  _buildSessionRequestBody() {
    const request = {
      mapType: this.options.mapType || 'roadmap',
    };

    if (this.options.language) {
      request.language = this.options.language;
    }
    if (this.options.region) {
      request.region = this.options.region;
    }
    if (this.options.imageFormat) {
      request.imageFormat = this.options.imageFormat;
    }
    if (this.options.scale) {
      request.scale = this.options.scale;
    }
    if (typeof this.options.highDpi === 'boolean') {
      request.highDpi = this.options.highDpi;
    }
    if (Array.isArray(this.options.layerTypes) && this.options.layerTypes.length) {
      request.layerTypes = this.options.layerTypes;
    }
    if (typeof this.options.overlay === 'boolean') {
      request.overlay = this.options.overlay;
    }
    if (
      Array.isArray(this.options.styles) &&
      this.options.styles.length &&
      request.mapType === 'roadmap'
    ) {
      request.styles = this.options.styles;
    }

    return request;
  }

  _buildTileUrl(coords) {
    if (!this._sessionToken) {
      throw new Error('Unable to build tile URL without a session token');
    }

    const base = (this.options.tilesEndpoint || DEFAULT_TILES_ENDPOINT).replace(/\/$/, '');
    const path = `${base}/${coords.z}/${coords.x}/${coords.y}`;

    const params = new URLSearchParams();
    params.set('session', this._sessionToken);
    params.set('key', this.options.apiKey);

    const orientation = this.options.orientation || 0;
    if (orientation) {
      params.set('orientation', String(orientation));
    }

    const extra = this.options.queryParameters;
    if (extra) {
      for (const [key, value] of Object.entries(extra)) {
        if (value === undefined || value === null) {
          continue;
        }
        params.set(key, String(value));
      }
    }

    return `${path}?${params.toString()}`;
  }

  setDataAttribution(text) {
    const normalized = text ? String(text).trim() : '';
    if (normalized === this._dataAttribution) {
      return;
    }
    this._dataAttribution = normalized;
    this._applyLeafletAttribution();
  }

  getDataAttribution() {
    return this._dataAttribution;
  }

  _integrateLeafletAttribution(map) {
    if (!map) {
      return;
    }
    const control = map.attributionControl;
    if (!control) {
      return;
    }

    if (this._originalAttributionPrefix === undefined) {
      this._originalAttributionPrefix = control.options.prefix;
    }

    if (this.options.googleAttributionPrefix !== null) {
      const prefix = this._computeAttributionPrefix();
      if (prefix !== undefined) {
        control.setPrefix(prefix);
      }
    }

    this._applyLeafletAttribution();
  }

  _restoreLeafletAttribution(map) {
    const control = map && map.attributionControl ? map.attributionControl : undefined;
    if (!control) {
      this._attributionEntry = undefined;
      return;
    }

    if (this._attributionEntry) {
      control.removeAttribution(this._attributionEntry);
      this._attributionEntry = undefined;
    }

    if (this._originalAttributionPrefix !== undefined && this.options.googleAttributionPrefix !== null) {
      control.setPrefix(this._originalAttributionPrefix);
    }
    this._originalAttributionPrefix = undefined;
  }

  _applyLeafletAttribution() {
    if (!this._map) {
      return;
    }
    const control = this._map.attributionControl;
    if (!control) {
      return;
    }

    const formatted = this._formatAttributionEntry(this._dataAttribution);

    if (this._attributionEntry) {
      control.removeAttribution(this._attributionEntry);
      this._attributionEntry = undefined;
    }

    if (formatted) {
      control.addAttribution(formatted);
      this._attributionEntry = formatted;
    }

    if (this.options.showGoogleLogo !== false) {
      this._ensureLogoControl(this._map);
    } else {
      this._removeLogoControl(this._map);
    }
  }

  _ensureLogoControl(map) {
    const targetMap = map || this._map;
    if (!targetMap) {
      return;
    }

    if (this.options.showGoogleLogo === false) {
      this._removeLogoControl(targetMap);
      return;
    }

    const desiredPosition = this.options.googleLogoPosition || 'bottomleft';

    if (
      this._logoControl &&
      typeof this._logoControl.getPosition === 'function' &&
      this._logoControl.getPosition() !== desiredPosition
    ) {
      this._removeLogoControl(targetMap);
    }

    if (!this._logoControl) {
      this._logoControl = new GoogleLogoControl(this, {
        position: desiredPosition,
      });
      this._logoControl.addTo(targetMap);
    } else if (!this._logoControl._map) {
      this._logoControl.addTo(targetMap);
    }

    if (typeof this._logoControl.update === 'function') {
      this._logoControl.update();
    }
  }

  _removeLogoControl(map) {
    if (!this._logoControl) {
      return;
    }

    const targetMap = map || this._logoControl._map || this._map;
    if (targetMap) {
      targetMap.removeControl(this._logoControl);
    } else if (typeof this._logoControl.remove === 'function') {
      this._logoControl.remove();
    }

    this._logoControl = undefined;
  }

  _computeAttributionPrefix() {
    if (typeof this.options.googleAttributionPrefix === 'string') {
      return this.options.googleAttributionPrefix;
    }

    if (this._originalAttributionPrefix !== undefined) {
      return this._originalAttributionPrefix;
    }

    return 'Leaflet';
  }

  _sanitizeLogoDpHeight(value) {
    const parsed = Number.parseFloat(String(value));
    if (!Number.isFinite(parsed)) {
      return DEFAULT_LOGO_DP_HEIGHT;
    }
    return Math.min(19, Math.max(16, parsed));
  }

  _formatAttributionEntry(text) {
    const parts = [];
    if (this._baseAttribution) {
      parts.push(this._baseAttribution);
    }
    const trimmed = text ? String(text).trim() : '';
    if (trimmed) {
      parts.push(trimmed);
    }
    return parts.join(' | ');
  }

  _bindViewportListeners(map) {
    if (!map || this._viewportListener) {
      return;
    }

    const handler = () => {
      void this.refreshViewportAttribution({
        applyAttribution: this.options.autoViewportAttribution !== false,
      });
    };

    this._viewportListener = handler;
    map.on('moveend', handler);
    map.on('zoomend', handler);
  }

  _unbindViewportListeners(map) {
    if (!map || !this._viewportListener) {
      return;
    }

    map.off('moveend', this._viewportListener);
    map.off('zoomend', this._viewportListener);
    this._viewportListener = undefined;
  }

  async refreshViewportAttribution(options = {}) {
    if (!this._map) {
      return;
    }
    if (!this._sessionToken) {
      await this._ensureSession();
    }
    if (!this._sessionToken) {
      return;
    }
    if (this._viewportQueued) {
      return this._viewportPromise;
    }

    const applyAttribution =
      options && Object.prototype.hasOwnProperty.call(options, 'applyAttribution')
        ? Boolean(options.applyAttribution)
        : true;

    const bounds = this._map.getBounds();
    const zoom = this._map.getZoom();
    this._viewportQueued = true;

    const desiredZoomValue = this._sanitizeZoomValue(zoom);
    const desiredZoom = Number.isFinite(desiredZoomValue) ? desiredZoomValue : 0;
    const requestZoom = this._computeViewportRequestZoom(desiredZoom);

    const promise = this._fetchViewportData(bounds, requestZoom)
      .then((result) => {
        const viewportData = result ? result.data : undefined;
        if (applyAttribution && viewportData && typeof viewportData.copyright === 'string') {
          this.setDataAttribution(viewportData.copyright.trim());
        }
        this._updateViewportDerivedState(viewportData, bounds);
      })
      .catch((error) => {
        if (typeof this.options.onViewportAttributionError === 'function') {
          this.options.onViewportAttributionError({ error });
        }
      })
      .finally(() => {
        this._viewportQueued = false;
        if (this._viewportPromise === promise) {
          this._viewportPromise = undefined;
        }
      });

    this._viewportPromise = promise;
    return promise;
  }

  async _fetchViewportData(bounds, zoom) {
    if (!bounds) {
      return undefined;
    }

    const fetchFn = this.options.fetchImplementation || globalThis.fetch;
    if (!fetchFn) {
      return undefined;
    }

    let attemptZoom = Number.isFinite(zoom) ? Math.max(0, Math.floor(zoom)) : 0;
    let lastError;

    while (attemptZoom >= 0) {
      try {
        const data = await this._executeViewportRequest(fetchFn, bounds, attemptZoom);
        return { data, zoom: attemptZoom };
      } catch (error) {
        if (!this._shouldRetryViewportRequest(error, attemptZoom)) {
          throw error;
        }

        const nextZoom = Math.max(0, attemptZoom - 1);
        this._recordViewportZoomCeiling(nextZoom);
        attemptZoom = nextZoom;
        lastError = error;
      }
    }

    throw lastError ?? new Error('Failed to fetch viewport attribution');
  }

  async _executeViewportRequest(fetchFn, bounds, zoom) {
    const endpoint = (this.options.viewportEndpoint || DEFAULT_VIEWPORT_ENDPOINT).replace(/\/$/, '');
    const params = new URLSearchParams();
    params.set('session', this._sessionToken);
    params.set('key', this.options.apiKey);
    params.set('zoom', String(zoom));
    params.set('north', this._clampLatitude(bounds.getNorth()).toString());
    params.set('south', this._clampLatitude(bounds.getSouth()).toString());
    params.set('east', this._normalizeLongitude(bounds.getEast()).toString());
    params.set('west', this._normalizeLongitude(bounds.getWest()).toString());

    const response = await fetchFn(`${endpoint}?${params.toString()}`);
    if (!response.ok) {
      const error = new Error(
        `Failed to fetch viewport attribution: ${response.status} ${response.statusText}`
      );
      error.name = 'GoogleViewportError';
      error.status = response.status;
      error.zoom = zoom;
      throw error;
    }

    const data = await response.json();
    if (!data || typeof data !== 'object') {
      return undefined;
    }
    return data;
  }

  _shouldRetryViewportRequest(error, zoom) {
    if (!error || typeof error !== 'object') {
      return false;
    }
    if (error.zoom !== undefined && error.zoom !== zoom) {
      return false;
    }
    const status = Number.isFinite(error.status) ? error.status : undefined;
    if (status === undefined) {
      return false;
    }
    if (status === 500 || status === 429) {
      return zoom > 0;
    }
    if (status >= 400 && status < 500) {
      return zoom > 0;
    }
    return false;
  }

  _recordViewportZoomCeiling(zoom) {
    if (!Number.isFinite(zoom)) {
      return;
    }
    const sanitized = Math.max(0, Math.floor(zoom));
    if (Number.isFinite(this._lastViewportMaxZoom)) {
      this._lastViewportMaxZoom = Math.min(this._lastViewportMaxZoom, sanitized);
    } else {
      this._lastViewportMaxZoom = sanitized;
    }

    if (this.options.autoViewportMaxNativeZoom) {
      const limited = this._limitMaxNativeZoom(sanitized);
      this._applyDynamicMaxNativeZoom(limited);
    }
  }

  _updateViewportDerivedState(viewportData, bounds) {
    const rects = viewportData && Array.isArray(viewportData.maxZoomRects)
      ? viewportData.maxZoomRects
      : undefined;
    if (!rects || !rects.length) {
      return;
    }

    const sanitizedRects = this._sanitizeViewportRects(rects);
    if (!sanitizedRects.length) {
      return;
    }

    const highestMaxZoom = this._computeHighestMaxZoom(sanitizedRects);
    if (Number.isFinite(highestMaxZoom)) {
      this._lastViewportMaxZoom = highestMaxZoom;
    }

    if (!this.options.autoViewportMaxNativeZoom) {
      return;
    }

    const maxNativeZoom = this._computeViewportMaxNativeZoom(sanitizedRects, bounds);
    if (maxNativeZoom === undefined) {
      return;
    }

    const limited = this._limitMaxNativeZoom(maxNativeZoom);
    this._applyDynamicMaxNativeZoom(limited);
  }

  _applyDynamicMaxNativeZoom(maxNativeZoom) {
    if (!Number.isFinite(maxNativeZoom)) {
      return;
    }

    const sanitized = Math.max(0, Math.floor(maxNativeZoom));
    if (!Number.isFinite(sanitized)) {
      return;
    }

    if (this.options.maxNativeZoom === sanitized && this._dynamicMaxNativeZoom === sanitized) {
      return;
    }

    this._dynamicMaxNativeZoom = sanitized;

    if (typeof this.setMaxNativeZoom === 'function') {
      this.setMaxNativeZoom(sanitized);
    } else {
      this.options.maxNativeZoom = sanitized;
    }

    this.options.maxNativeZoom = sanitized;

    if (this._map) {
      this.redraw();
    }
  }

  _computeViewportMaxNativeZoom(rects, bounds) {
    if (!this._map || !Array.isArray(rects) || rects.length === 0) {
      return undefined;
    }

    // Prefer the highest maxZoom rectangle that covers the map centre, then fall back to any
    // intersecting rect, and finally the overall maximum as a coarse default.
    const center = this._map.getCenter();
    const centerLat = this._clampLatitude(center.lat);
    const centerLng = this._normalizeLongitude(center.lng);

    let bestContaining;
    for (const rect of rects) {
      if (this._rectContainsLatLng(rect, centerLat, centerLng)) {
        bestContaining = bestContaining === undefined ? rect.maxZoom : Math.max(bestContaining, rect.maxZoom);
      }
    }

    if (bestContaining !== undefined) {
      return bestContaining;
    }

    if (bounds) {
      const matches = [];
      for (const rect of rects) {
        if (this._rectIntersectsBounds(rect, bounds)) {
          matches.push(rect.maxZoom);
        }
      }
      if (matches.length) {
        return Math.max(...matches);
      }
    }

    let highest;
    for (const rect of rects) {
      highest = highest === undefined ? rect.maxZoom : Math.max(highest, rect.maxZoom);
    }
    return highest;
  }

  _sanitizeViewportRects(rects) {
    if (!Array.isArray(rects) || !rects.length) {
      return [];
    }
    const sanitizedRects = [];
    for (const rect of rects) {
      const sanitized = this._sanitizeViewportRect(rect);
      if (sanitized) {
        sanitizedRects.push(sanitized);
      }
    }
    return sanitizedRects;
  }

  _computeHighestMaxZoom(rects) {
    if (!Array.isArray(rects) || !rects.length) {
      return undefined;
    }
    let highest;
    for (const rect of rects) {
      highest = highest === undefined ? rect.maxZoom : Math.max(highest, rect.maxZoom);
    }
    return highest;
  }

  _computeViewportRequestZoom(zoom) {
    if (!Number.isFinite(zoom)) {
      return 0;
    }
    const sanitized = Math.max(0, Math.floor(zoom));
    const ceilings = [];
    if (Number.isFinite(this._lastViewportMaxZoom)) {
      ceilings.push(Math.floor(this._lastViewportMaxZoom));
    }
    if (Number.isFinite(this._dynamicMaxNativeZoom)) {
      ceilings.push(Math.floor(this._dynamicMaxNativeZoom));
    }
    if (Number.isFinite(this._userMaxNativeZoom)) {
      ceilings.push(Math.floor(this._userMaxNativeZoom));
    }
    if (Number.isFinite(this._userMaxZoom)) {
      ceilings.push(Math.floor(this._userMaxZoom));
    }

    if (!ceilings.length) {
      return sanitized;
    }

    const ceiling = Math.max(...ceilings);
    if (!Number.isFinite(ceiling)) {
      return sanitized;
    }

    return Math.min(sanitized, ceiling < 0 ? 0 : ceiling);
  }

  _sanitizeViewportRect(rect) {
    if (!rect || typeof rect !== 'object') {
      return undefined;
    }

    const maxZoom = this._sanitizeZoomValue(rect.maxZoom);
    if (maxZoom === undefined) {
      return undefined;
    }

    const north = this._sanitizeLatitudeValue(rect.north);
    const south = this._sanitizeLatitudeValue(rect.south);
    const east = this._sanitizeLongitudeValue(rect.east);
    const west = this._sanitizeLongitudeValue(rect.west);

    if (north === undefined || south === undefined || east === undefined || west === undefined) {
      return undefined;
    }

    if (south > north) {
      return undefined;
    }

    return { maxZoom, north, south, east, west };
  }

  _sanitizeZoomValue(value) {
    if (value === undefined || value === null) {
      return undefined;
    }
    const parsed = typeof value === 'number' ? value : Number.parseInt(String(value), 10);
    if (!Number.isFinite(parsed)) {
      return undefined;
    }
    const normalized = Math.floor(parsed);
    return normalized < 0 ? 0 : normalized;
  }

  _sanitizeLatitudeValue(value) {
    if (value === undefined || value === null) {
      return undefined;
    }
    const parsed = typeof value === 'number' ? value : Number.parseFloat(String(value));
    if (!Number.isFinite(parsed)) {
      return undefined;
    }
    return this._clampLatitude(parsed);
  }

  _sanitizeLongitudeValue(value) {
    if (value === undefined || value === null) {
      return undefined;
    }
    const parsed = typeof value === 'number' ? value : Number.parseFloat(String(value));
    if (!Number.isFinite(parsed)) {
      return undefined;
    }
    return this._normalizeLongitude(parsed);
  }

  _rectContainsLatLng(rect, lat, lng) {
    if (lat < rect.south - LATITUDE_EPSILON || lat > rect.north + LATITUDE_EPSILON) {
      return false;
    }
    return this._longitudeRangeContains(rect.west, rect.east, lng);
  }

  _rectIntersectsBounds(rect, bounds) {
    if (!bounds) {
      return false;
    }
    const boundsNorth = this._clampLatitude(bounds.getNorth());
    const boundsSouth = this._clampLatitude(bounds.getSouth());

    if (boundsSouth > rect.north + LATITUDE_EPSILON || boundsNorth < rect.south - LATITUDE_EPSILON) {
      return false;
    }

    const boundsWest = this._normalizeLongitude(bounds.getWest());
    const boundsEast = this._normalizeLongitude(bounds.getEast());
    return this._longitudeRangesIntersect(rect.west, rect.east, boundsWest, boundsEast);
  }

  _longitudeRangeContains(west, east, value) {
    if (west <= east) {
      return value >= west - LONGITUDE_EPSILON && value <= east + LONGITUDE_EPSILON;
    }
    return value >= west - LONGITUDE_EPSILON || value <= east + LONGITUDE_EPSILON;
  }

  _longitudeRangesIntersect(westA, eastA, westB, eastB) {
    const segmentsA = this._toLongitudeSegments(westA, eastA);
    const segmentsB = this._toLongitudeSegments(westB, eastB);

    for (const [startA, endA] of segmentsA) {
      for (const [startB, endB] of segmentsB) {
        const start = Math.max(startA, startB);
        const end = Math.min(endA, endB);
        if (start <= end + LONGITUDE_EPSILON) {
          return true;
        }
      }
    }

    return false;
  }

  _toLongitudeSegments(west, east) {
    if (west <= east) {
      return [[west, east]];
    }
    return [
      [west, 180 - LONGITUDE_EPSILON],
      [-180 + LONGITUDE_EPSILON, east],
    ];
  }

  _limitMaxNativeZoom(value) {
    if (!Number.isFinite(value)) {
      return undefined;
    }
    const clampedValue = Math.floor(value);
    let result = clampedValue;
    if (this._userMaxNativeZoom !== undefined) {
      result = Math.min(result, this._userMaxNativeZoom);
    }
    if (this._userMaxZoom !== undefined) {
      result = Math.min(result, Math.floor(this._userMaxZoom));
    }
    return result < 0 ? 0 : result;
  }

  _clampLatitude(lat) {
    if (!Number.isFinite(lat)) {
      return 0;
    }
    return Math.min(90 - LATITUDE_EPSILON, Math.max(-90 + LATITUDE_EPSILON, lat));
  }

  _normalizeLongitude(lng) {
    if (!Number.isFinite(lng)) {
      return 0;
    }
    let normalized = ((lng + 180) % 360 + 360) % 360 - 180;
    const min = -180 + LONGITUDE_EPSILON;
    const max = 180 - LONGITUDE_EPSILON;
    if (normalized < min) {
      normalized = min;
    } else if (normalized > max) {
      normalized = max;
    }
    return normalized;
  }
}

class GoogleLogoControl extends Control {
  constructor(layer, options = {}) {
    super({ position: options.position || layer.options.googleLogoPosition || 'bottomleft' });
    this._layer = layer;
    this._image = undefined;
  }

  onAdd() {
    const container = DomUtil.create('div', 'leaflet-control leaflet-google-logo');
    container.style.background = 'transparent';
    container.style.border = 'none';
    container.style.padding = '0';
    container.style.pointerEvents = 'none';
    container.style.boxShadow = 'none';

    this._image = DomUtil.create('img', 'leaflet-google-logo-image', container);
    this._image.alt = 'Google';
    this._image.draggable = false;
    this._image.decoding = 'async';
    this._image.referrerPolicy = 'no-referrer';
    this._image.style.display = 'block';
    this._image.style.pointerEvents = 'auto';
    this._image.style.userSelect = 'none';
    this._image.style.background = 'transparent';
    this._image.style.border = 'none';

    this.update();

    return container;
  }

  onRemove() {
    this._image = undefined;
  }

  update() {
    if (!this._image) {
      return;
    }

    const logoUrl = this._layer.options.googleLogoUrl || DEFAULT_LOGO_URL;
    const dpHeight = this._layer._sanitizeLogoDpHeight(this._layer.options.googleLogoHeight);
    // Google requires 16-19dp; convert dp to CSS pixels using the active pixel ratio to maintain physical size.
    const ratioSource =
      (typeof globalThis !== 'undefined' && globalThis.devicePixelRatio) ||
      (typeof window !== 'undefined' && window.devicePixelRatio) ||
      1;
    const pixelRatio = Number.isFinite(ratioSource) && ratioSource > 0 ? ratioSource : 1;
    const pixelHeight = Math.max(1, Math.round(dpHeight * pixelRatio));

    if (this._image.src !== logoUrl) {
      this._image.src = logoUrl;
    }
    this._image.style.height = `${pixelHeight}px`;
    this._image.style.width = 'auto';
    this._image.height = pixelHeight;
  }
}

export function googleTileLayer(options) {
  return new GoogleTileLayer(options);
}

// Expose a Leaflet-friendly namespace when the global L object is available.
if (typeof window !== 'undefined' && window.L) {
  const leafletInstance = window.L;
  if (!leafletInstance.GoogleTileLayer) {
    leafletInstance.GoogleTileLayer = GoogleTileLayer;
  }
  if (!leafletInstance.googleTileLayer) {
    leafletInstance.googleTileLayer = (options) => new GoogleTileLayer(options);
  }
}
